if (!customElements.get('product-picker')) {
  class ProductPicker extends HTMLElement {
    constructor() {
      super();
      this.section = this.closest('.js-product') || document;
      this.optionSelectors = this.querySelectorAll('.option-selector');
      this.data = this.getProductData();
      this.currentUrl = this.dataset.currentUrl;

      this.addEventListener('change', this.handleProductChange.bind(this));
      this.initSwatchScrollButtons();
      this.initColorOverflow();

      this.setAttribute('loaded', '');
    }

    /**
     * Initialises scroll arrow buttons for overflowing swatch rows.
     * Only activates on mobile — desktop uses the +X expand button instead.
     */
    initSwatchScrollButtons() {
      this.querySelectorAll('.option-selector__btns-wrapper').forEach((wrapper) => {
        const track = wrapper.querySelector('.option-selector__btns');
        const btnLeft = wrapper.querySelector('.swatch-scroll-btn--left');
        const btnRight = wrapper.querySelector('.swatch-scroll-btn--right');

        if (!track || !btnLeft || !btnRight) return;

        const scrollAmount = 120;
        const isMobile = () => window.matchMedia('(max-width: 768px)').matches;

        const updateButtons = () => {
          if (!isMobile()) {
            btnLeft.classList.add('is-hidden');
            btnRight.classList.add('is-hidden');
            wrapper.classList.remove('show-left', 'show-right');
            return;
          }

          const scrollable = track.scrollWidth > track.clientWidth;
          const atStart = track.scrollLeft <= 2;
          const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;

          btnLeft.classList.toggle('is-hidden', !scrollable || atStart);
          btnRight.classList.toggle('is-hidden', !scrollable || atEnd);
          wrapper.classList.toggle('show-left', scrollable && !atStart);
          wrapper.classList.toggle('show-right', scrollable && !atEnd);
        };

        btnLeft.addEventListener('click', () => {
          track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        });

        btnRight.addEventListener('click', () => {
          track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateButtons, { passive: true });

        const ro = new ResizeObserver(updateButtons);
        ro.observe(track);

        updateButtons();
        window.addEventListener('resize', updateButtons, { passive: true });
      });
    }

    /**
     * Initialises the +X show more button for overflowing items on desktop.
     * Hidden on mobile — scroll is used there instead.
     */
    initColorOverflow() {
      this.querySelectorAll('.option-selector__btns-wrapper--color').forEach((wrapper) => {
        const track = wrapper.querySelector('.option-selector__btns');
        const showMoreBtn = track && track.querySelector('.opt-label--show-more');
        if (!showMoreBtn) return;

        showMoreBtn.addEventListener('click', () => {
          track.querySelectorAll('.opt-label--overflow').forEach((el) => {
            el.classList.remove('opt-label--overflow');
          });
          showMoreBtn.remove();
        });
      });
    }

    /**
     * Handles 'change' events on the product picker element.
     * Navigates the browser to the selected product's URL.
     * @param {object} evt - Event object.
     */
    handleProductChange(evt) {
      const input = evt.target;
      if (!input || !input.classList.contains('opt-btn')) return;
      if (input.classList.contains('is-unavailable')) return;

      const productUrl = input.dataset.productUrl;
      if (!productUrl) return;

      const selectedUrl = new URL(productUrl, window.location.origin);
      if (selectedUrl.pathname === window.location.pathname) return;

      window.location = productUrl;
    }

    /**
     * Gets the product data for the picker.
     * @returns {?object}
     */
    getProductData() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }
  }

  customElements.define('product-picker', ProductPicker);
}